export default __webpack_public_path__ + "static/media/icon-workplace.73eafbe9.png";